import React from "react";

const Article = () => {
  return (
    <div className="protocols mt-5 mb-20">
      <div>
        <center>
          <details>
            <summary id="primary">
              <mark>
                <b>1. Primary Culture </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/1.pdf"
              width="800"
              height="500"
              aria-label="Primary Culture"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="secondary">
              <mark>
                <b>1.2 Secondary Culture </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/1-2.pdf"
              width="800"
              height="500"
              aria-label="Secondary Culture"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="transformation">
              <mark>
                <b>2. Transformation </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/2.pdf"
              width="800"
              height="500"
              aria-label="Transformation"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="OD">
              <mark>
                <b>3. Measure OD </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/3.pdf"
              width="800"
              height="500"
              aria-label="Measure OD"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="autoclave">
              <mark>
                <b>4. Autoclave </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/4.pdf"
              width="800"
              height="500"
              aria-label="Autoclave"
            ></object>
          </details>
        </center>
      
        <center>
          <details>
            <summary id="agarose-gel">
              <mark>
                <b>5. Prepare agarose gel </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/5.pdf"
              width="800"
              height="500"
              aria-label="Prepare Agarose Gel"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="agarose-plates">
              <mark>
                <b>6. Pour agarose plates </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/6.pdf"
              width="800"
              height="500"
              aria-label="Pour Agarose Plates"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="boiling wester">
              <mark>
                <b>7. Boiling for Western Blot </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/7.pdf"
              width="800"
              height="500"
              aria-label="Boiling For Western Blot"
            ></object>
          </details>
        </center>
          <center>
            <details>
              <summary id="half-life-boil">
                <mark>
                  <b>8 Half-life experiment: Boiling </b>
                </mark>
              </summary>
              <object
                data="https://static.igem.wiki/teams/4888/wiki/prots/8.pdf"
                width="800"
                height="500"
                aria-label="Half Life Experiment - Boiling"
              ></object>
            </details>
          </center>

        <center>
          <details>
            <summary id="streak-culture">
              <mark>
                <b>9. Streak cultures from glycerol stock </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/9.pdf"
              width="800"
              height="500"
              aria-label="Dissolve DNA"
            ></object>
          </details>
        </center>

        <center>
          <details>
            <summary id="dissolve-dna">
              <mark>
                <b>10. Dissolve DNA</b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/10.pdf"
              width="800"
              height="500"
              aria-label="Proteinase K Assay"
            ></object>
          </details>
        </center>
        </div>

      <div>
      <center>
          <details>
            <summary id="pk">
              <mark>
                <b>11. Proteinase K assay </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/11.pdf"
              width="800"
              height="500"
              aria-label="Sonication Protocol"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="sonication">
              <mark>
                <b>12. Sonication </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/12.pdf"
              width="800"
              height="500"
              aria-label="Sonication Protocol"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="BCA">
              <mark>
                <b>13. BCA </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/13.pdf"
              width="800"
              height="500"
              aria-label="BCA"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="western">
              <mark>
                <b>14. Western Blot </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/14.pdf"
              width="800"
              height="500"
              aria-label="Western blotting protocol"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="purification">
              <mark>
                <b>15. Purify protein using MagneHis Purification system</b>
              </mark>
            </summary>
            <object
            data="https://static.igem.wiki/teams/4888/wiki/prots/15.pdf"
            width="800"
            height="500"
            aria-label="purification"
            >
            </object>
          </details>
        </center>
        <center>
          <details>
            <summary id="pcr-primer">
              <mark>
                <b>16.1 PCR: Prepare primer stock </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/16-1.pdf"
              width="800"
              height="500"
              aria-label="PCR: prepare primer stock"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="pcr">
              <mark>
                <b>16.2 PCR </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/16-2.pdf"
              width="800"
              height="500"
              aria-label="PCR"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="dissolve-plasmid">
              <mark>
                <b>17. Dissolving plasmid </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/17.pdf"
              width="800"
              height="500"
              aria-label="Dissolving plasmid"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="gfp">
              <mark>
                <b>18. GFP nanobody assay </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/18.pdf"
              width="800"
              height="500"
              aria-label="GFP"
            ></object>
          </details>
        </center>

        <center>
          <details>
            <summary id="IF">
              <mark>
                <b>19. Immunofluorescence for surface expression verification </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/19.pdf"
              width="800"
              height="500"
              aria-label="IF"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="KLD">
              <mark>
                <b>20. KLD reaction </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/20.pdf"
              width="800"
              height="500"
              aria-label="KLD"
            ></object>
          </details>
        </center>
        </div>

<div>
        <center>
          <details>
            <summary id="hifi">
              <mark>
                <b>21. Hifi cloning </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/21.pdf"
              width="800"
              height="500"
              aria-label="Hifi"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="viability">
              <mark>
                <b>22. Viability assay of D1 and D1+D2 </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/22.pdf"
              width="800"
              height="500"
              aria-label="viability"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="mucus-binding">
              <mark>
                <b>23. Mucus binding experiment </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/23.pdf"
              width="800"
              height="500"
              aria-label="mucus-binding"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="zinc-binding">
              <mark>
                <b>24. Zinc binding experiment </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/24-z.pdf"
              width="800"
              height="500"
              aria-label="zinc-binding"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="cadmium-binding">
              <mark>
                <b>25. Cadmium binding experiment </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/25.pdf"
              width="800"
              height="500"
              aria-label="cadmium-binding"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="DTT">
              <mark>
                <b>26. DTT and Urea with boiling</b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/26.pdf"
              width="800"
              height="500"
              aria-label="DTT"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="coomassie">
              <mark>
                <b>27. Coomassie blue staining </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/27.pdf"
              width="800"
              height="500"
              aria-label="coomassie"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="coomassie">
              <mark>
                <b>27. Coomassie blue staining </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/27.pdf"
              width="800"
              height="500"
              aria-label="coomassie"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="Uracil">
              <mark>
                <b>28. Speed-up Uracilation </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/28-speed-up-uracilation-in-secondary-cultures.pdf"
              width="800"
              height="500"
              aria-label="Uracil"
            ></object>
          </details>
        </center>
        <center>
          <details>
            <summary id="Arabinose">
              <mark>
                <b>29. Arabinose Ampicilin Plates </b>
              </mark>
            </summary>
            <object
              data="https://static.igem.wiki/teams/4888/wiki/prots/29.pdf"
              width="800"
              height="500"
              aria-label="Arabinose"
            ></object>
          </details>
        </center>
      </div>
    </div>
  );
};

export default Article;
